import type { ProjectMember } from '../types/api'
import { apiClient } from './client'

export async function listProjectMembers(projectId: number): Promise<ProjectMember[]> {
  return apiClient.get<ProjectMember[]>(`/projects/${projectId}/members`)
}

export async function addProjectMember(
  projectId: number,
  data: { userId: number; projectRole: 'manager' | 'viewer' }
): Promise<Omit<ProjectMember, 'username' | 'email'>> {
  return apiClient.post(`/projects/${projectId}/members`, data)
}

export async function removeProjectMember(
  projectId: number,
  userId: number
): Promise<{ deleted: boolean; userId: number }> {
  return apiClient.delete(`/projects/${projectId}/members/${userId}`)
}
